<template>
  <div class="wrapper">
    <div class="tabs">
      <div
        class="tab"
        v-for="(item,i) in tabs"
        :key="i"
        @click="contentIndex=i"
        :class="contentIndex==i?'active':''"
      >{{item}}</div>
    </div>
    <div class="main" v-show="contentIndex==0">
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        label-position="top"
      >
        <el-form-item label="原密码" prop="oldPass">
          <el-input v-model.number="ruleForm.oldPass" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="pass">
          <el-input type="password" v-model="ruleForm.pass" autocomplete="off" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"  show-password></el-input>
        </el-form-item>
        <div class="post-btn" @click="submitForm('ruleForm')">提交</div>
      </el-form>
    </div>
    <div class="main" v-show="contentIndex==1">
      <el-form
        :model="ruleForm1"
        status-icon
        :rules="rules"
        ref="ruleForm1"
        label-width="100px"
        class="demo-ruleForm"
        label-position="top"
      >
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model.number="ruleForm1.mobile"></el-input>
        </el-form-item>
        <div class="codeInput-wrap">
          <el-form-item label="验证码" prop="code" class="codeInput">
            <el-input v-model.number="ruleForm1.code"></el-input>
          </el-form-item>
          <div class="code-btn" @click="sendCode" v-show="verification">{{sendText}}</div>
          <div class="code-btn not" v-show="!verification">重新发送({{timer}})</div>
        </div>

        <el-form-item label="新密码" prop="pass1">
          <el-input type="password" v-model="ruleForm1.pass1" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass1">
          <el-input type="password" v-model="ruleForm1.checkPass1" autocomplete="off"></el-input>
        </el-form-item>
        <div class="post-btn" @click="submitForm1('ruleForm1')">提交</div>
      </el-form>
    </div>
  </div>
</template>

<script>
import InputGroup from "@/components/layout/InputGroup.vue";
import { inputCheckPhone } from "@/utils";
export default {
  name: "SafeCenter",
  components: { InputGroup },
  props: {},
  data() {
    var checkOldPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("原密码不能为空"));
      }
      callback();
    };
    var validateFormPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validateFormPass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validateForm1Pass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm1.checkPass1 !== "") {
          this.$refs.ruleForm1.validateField("checkPass1");
        }
        callback();
      }
    };
    var validateForm1Pass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm1.pass1) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var checkMobile = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请输入手机号"));
      } else if (!inputCheckPhone(value)) {
        return callback(new Error("请输入正确的手机号"));
      }
      callback();
    };
    return {
      verification: true,
      sendText: "获取验证码",
      timer: 60,
      auth_timer: "",
      ruleForm: {
        pass: "",
        checkPass: "",
        oldPass: ""
      },
      ruleForm1: {
        mobile: "",
        code: "",
        pass1: "",
        checkPass1: ""
      },
      rules: {
        pass: [{ validator: validateFormPass, trigger: "blur" }],
        checkPass: [{ validator: validateFormPass2, trigger: "blur" }],
        pass1: [{ validator: validateForm1Pass, trigger: "blur" }],
        checkPass1: [{ validator: validateForm1Pass2, trigger: "blur" }],
        oldPass: [{ validator: checkOldPass, trigger: "blur" }],
        mobile: [{ validator: checkMobile, trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      },
      tabs: ["修改密码", "重置密码"],
      contentIndex: 0
    };
  },
  watch: {},
  computed: {},
  methods: {
    sendCode() {
      if (!this.ruleForm1.mobile || !inputCheckPhone(this.ruleForm1.mobile)) {
        return this.$msg("请输入正确手机号", "warning");
      } else {
        this.$api
          .sms({ mobile: this.ruleForm1.mobile, code: "veri" })
          .then(res => {
            if (res.status) {
              this.verification = false;
              this.countDown(); // 执行验证码计时
            } else {
              this.$msg(res.msg, "error");
            }
          });
      }
    },
    countDown() {
      let auth_timer = setInterval(() => {
        // 定时器设置每秒递减
        this.timer--; // 递减时间
        if (this.timer <= 0) {
          this.verification = true; 
          this.timer = 60;
          clearInterval(auth_timer);
          this.sendText = "重新发送";
        }
      }, 1000);
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.editPass();
        } else {
          return false;
        }
      });
    },
    submitForm1(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.resetPass();
        } else {
          return false;
        }
      });
    },
    resetPass() {
      let data = {
        mobile: this.ruleForm1.mobile,
        code: this.ruleForm1.code,
        newpwd: this.ruleForm1.pass1,
        repwd: this.ruleForm1.checkPass1
      };
      this.$api.forgotPwd(data).then(res => {
        this.resultStatus(res);
      });
    },
    editPass() {
      let data = {
        pwd: this.ruleForm.pass,
        newpwd: this.ruleForm.checkPass,
        repwd: this.ruleForm.oldPass
      };
      this.$api.editPwd(data).then(res => {
        this.resultStatus(res);
      });
    },
    resultStatus(res) {
      if (res.status) {
        this.$msg("请重新登录", "warning");
        this.$storage.remove("userToken");
        this.$router.replace({ name: "login" });
      } else {
        this.$msg(res.msg, "error");
      }
    }
  },
  created() {},
  mounted() {},
  destroyed() {
    clearInterval(this.auth_timer);
  }
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";
.wrapper {
  height: 600px;
  .tabs {
    display: flex;
    padding: 15px 0;
    .tab {
      padding: 0 20px;
      cursor: pointer;
      &:not(:last-of-type) {
        border-right: 1px solid $border;
      }
      &.active {
        color: $theme-color;
      }
    }
  }
  .main {
    width: 300px;
    margin-top: 20px;
  }
}
.codeInput-wrap {
  display: flex;
  position: relative;
  .codeInput {
    width: 216px;
  }
  .code-btn {
    position: absolute;
    top: 50px;
    right: 0;
    width: 84px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: #ea4b49;
    font-weight: 400;
    border: 1px solid #dcdfe6;
    border-left: none;
    cursor: pointer;
    z-index: 999;
    &.not {
      color: #999;
    }
  }
}
.post-btn {
  width: 120px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  text-align: center;
  border-radius: none;
  background: $theme-color;
  cursor: pointer;
}
</style>